const items = [
  { text: 'Kompletní nastavení a konfigurace', sub: 'Propojení všech vašich systémů — my to uděláme za vás', price: '8 000 Kč' },
  { text: 'Mapování dokladů a předkontací', sub: 'Faktury, objednávky, platby — správně zaúčtované od prvního dne', price: '5 000 Kč' },
  { text: 'Napojení na Money S3', sub: 'Certifikovaná integrace — ne žádný hack přes CSV', price: '4 000 Kč' },
  { text: 'Zaškolení celého týmu', sub: 'Portál, logy, řešení problémů — ukážeme vám vše', price: '3 000 Kč' },
  { text: 'Test na reálných datech před spuštěním', sub: 'Žádné překvapení po ostrém startu', price: '2 000 Kč' },
  { text: 'CSV/XLSX/XML Mapper s AI rozpoznáváním', sub: 'Importujte cokoliv — systém rozpozná strukturu automaticky', price: '5 000 Kč' },
];

export default function ValueStack() {
  return (
    <section className="value-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label gold">Co vše je v ceně</span>
          <h2>Tohle všechno dostanete<br />za <span style={{ color: 'var(--gold)' }}>2 000 Kč</span> jednorázově</h2>
          <p>Implementace, kterou jinde platíte desítkami tisíc. U nás za cenu jednoho firemního oběda pro tým.</p>
        </div>
        <div className="value-stack">
          {items.map((item, i) => (
            <div key={i} className="value-item">
              <div className="value-item-left">
                <div className="value-check">&#10003;</div>
                <div className="value-item-text">{item.text}<small>{item.sub}</small></div>
              </div>
              <div className="value-price">{item.price}</div>
            </div>
          ))}
          <div className="value-total">
            <div className="value-total-row"><div className="value-total-label">Hodnota při samostatném nákupu</div><div className="value-total-number">27 000 Kč</div></div>
            <div className="value-total-actual"><div className="label">Vaše cena za implementaci</div><div className="price">2 000 Kč <small>/ účetní jednotka</small></div></div>
          </div>
        </div>
      </div>
    </section>
  );
}
